<div class="progress-bar-container">
  <div class="progress-bar-value"></div>
</div>
